// client/src/components/forms/Select.js
//
// Bare dropdown. Same visual treatment as TextInput. Native <select>
// under the hood — mobile handles its own picker sheet, desktop shows
// the platform's dropdown. Extra pr-8 gives the native chevron room so
// long option text doesn't collide with it.
//
// Callsites supply <option> elements as children:
//   <Select value={x} onChange={setX}>
//     <option value="Normal">Normal</option>
//     <option value="Urgent">Urgent</option>
//   </Select>

export function Select({
  value,
  onChange,
  className = '',
  children,
  ...rest
}) {
  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value)}
      className={[
        'block w-full',
        'bg-paper text-ink',
        'border border-rule rounded-md',
        'pl-3 pr-8 py-2',
        'text-base',
        'focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'appearance-auto',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </select>
  );
}